<cap-rubrik [isClosable]="false" [isOpen]="true" class="externe-daten">
  <ng-container title>
    <h2 class="mb-0">{{ "stime.amtlicheBewertung" | translate }}</h2>
  </ng-container>

  @if (amtlicherWertDetail) {
    <cap-beschreibung-table-wrapper [tableFullWidth]="tableFullWidth" class="my-0">
          <span class="cap-table-wrapper-title" style="font-weight: bold">
            {{ amtlicherWertDetail.note }}
          </span>
    </cap-beschreibung-table-wrapper>
    <cap-beschreibung-table-wrapper [tableFullWidth]="false" class="my-2">
          <span class="cap-table-wrapper-title" style="font-weight: bold">
            {{ "stime.gesamtflaeche" | translate  }}
          </span>
      <span class="cap-table-wrapper-content" style="font-weight: normal">
            {{ amtlicherWertDetail.gesamtflaeche | decimalHochkomma }}
          </span>
    </cap-beschreibung-table-wrapper>

    <cap-beschreibung-table-wrapper [tableFullWidth]="false" class="my-2">
      <span class="cap-table-wrapper-title" style="font-weight: bold">
        {{ "stime.gesamtwert" | translate  }}
      </span>
      <span class="cap-table-wrapper-content" style="font-weight: normal">
       {{ joinSchaetzungDescription(amtlicherWertDetail.gesamtwert | betrag , "stime.chf" | translate)  }}
      </span>
    </cap-beschreibung-table-wrapper>
    <cap-beschreibung-table-wrapper [tableFullWidth]="false" class="my-2">
        <span class="cap-table-wrapper-title" style="font-weight: bold">
        {{ "stime.validfrom" | translate  }}
      </span>
        <span class="cap-table-wrapper-content" style="font-weight: normal">
          {{ amtlicherWertDetail.validFrom | date:'dd.MM.yyyy hh:mm' }}

      </span>
    </cap-beschreibung-table-wrapper>
    <div>
      <br>
    </div>
    <cap-beschreibung-table-wrapper [tableFullWidth]="tableFullWidth" class="my-2">
          <span class="cap-table-wrapper-title" style="font-weight: bold">
            {{ "stime.land" | translate  }}
          </span>
      <ng-container class="cap-table-wrapper-content">
        <table class="cap-table-detail">
          <thead>
            <tr>
              <th style="width: 30%">
                {{"stime.description" | translate }}
              </th>
              <th style="width: 30%">
                {{"stime.flaeche" | translate }}
              </th>
              <th style="width: 40%">
                {{ "stime.schaetzung" | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            @for (land of amtlicherWertDetail?.land; track land) {
            <tr>
              <td style="width: 30%">
                {{land.description }}
              </td>
              <td style="width: 30%">
                {{land.flaeche | decimalHochkomma }}
              </td>
              <td style="width: 40%">
                {{ joinSchaetzungDescription(land.schaetzung | betrag,land.schaetzungDescription ) }}
              </td>
            </tr>
            }
          </tbody>
        </table>
      </ng-container>
    </cap-beschreibung-table-wrapper>

    <cap-beschreibung-table-wrapper [tableFullWidth]="tableFullWidth" class="my-2">
          <span class="cap-table-wrapper-title" style="font-weight: bold">
            {{ "stime.gebaeude" | translate  }}
          </span>
      <ng-container class="cap-table-wrapper-content">
        <table class="cap-table-detail">
          <thead>
            <tr>
              <th style="width: 30%">
                {{"stime.description" | translate }}
              </th>
              <th style="width: 30%">
                {{"stime.flaeche" | translate }}
              </th>
              <th style="width: 40%">
                {{ "stime.schaetzung" | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            @for (geb of amtlicherWertDetail?.gebaeude; track geb) {
              <tr>
                <td style="width: 30%">
                  <table>
                    <td style="width: 40px">
                      {{geb.key }}
                    </td>
                    <td>
                      {{geb.type }}
                    </td>
                  </table>
                </td>
                <td style="width: 30%">
                  {{geb.flaeche | decimalHochkomma }}
                </td>
                <td style="width: 40%">
                  {{ joinSchaetzungDescription(geb.schaetzung | betrag,geb.schaetzungDescription ) }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </ng-container>
    </cap-beschreibung-table-wrapper>
  }
</cap-rubrik>



